module.exports = __webpack_public_path__ + "static/img/12.070f9d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/12.png
// module id = 5gA6
// module chunks = 0